var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_41_356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C9.15977 17 8.35623 16.8524 7.61247 16.5826C7.28463 16.4636 6.92007 16.437 6.56448 16.5244C5.60939 16.759 4.63437 16.9078 3.65106 16.9686C4.02083 15.9944 4.14858 14.9412 4.01859 13.9008C3.98967 13.6694 3.91398 13.4664 3.82407 13.2985C3.29846 12.3167 3 11.1947 3 10C3 6.13401 6.13401 3 10 3ZM19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 11.5167 1.37598 12.9485 2.04062 14.2044C2.14435 15.1303 1.95212 16.0682 1.48733 16.8816L1.44632 16.9533C0.9252 17.8653 1.58368 19 2.63403 19C4.10189 19 5.56133 18.8251 6.98192 18.4812C7.92665 18.8174 8.94307 19 10 19C14.9706 19 19 14.9706 19 10ZM21.3552 9.25812C20.9331 9.61423 20.8795 10.2451 21.2356 10.6673C22.3371 11.973 23 13.6578 23 15.5C23 16.7826 22.6789 17.9872 22.1135 19.0408C22.0228 19.2097 21.9476 19.4124 21.9185 19.6425C21.7755 20.7732 21.9218 21.9185 22.3392 22.9723C21.2529 22.9111 20.1756 22.7493 19.1212 22.4894C18.7653 22.4017 18.3998 22.4281 18.0708 22.5481C17.2702 22.8402 16.4049 23 15.5 23C13.6578 23 11.973 22.3371 10.6673 21.2356C10.2451 20.8795 9.61423 20.9331 9.25812 21.3552C8.90201 21.7774 8.95555 22.4083 9.3777 22.7644C11.0307 24.1588 13.1684 25 15.5 25C16.6223 25 17.7012 24.805 18.7033 24.4461C20.2136 24.8133 21.7654 25 23.3263 25C24.3943 25 25.0639 23.8462 24.534 22.919L24.534 22.9189L24.4904 22.8427C23.988 21.9635 23.7814 20.9491 23.896 19.9484C24.601 18.6203 25 17.1053 25 15.5C25 13.1684 24.1587 11.0307 22.7644 9.3777C22.4083 8.95555 21.7774 8.90202 21.3552 9.25812ZM6 11C6.55228 11 7 10.5523 7 10C7 9.44772 6.55228 9 6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11ZM11 10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10C9 9.44772 9.44771 9 10 9C10.5523 9 11 9.44772 11 10ZM14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11Z",
    fill: "#37352F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_41_356",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 0 0.745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_356"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_41_356",
    result: "effect2_dropShadow_41_356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_41_356",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.aea1b7fec7c122dd083096e402515861.svg";
export { ForwardRef as ReactComponent };